import React from "react";
import { Col, Row } from "react-bootstrap";
import NotificationsTable from "../../../components/notifications-table/NotificationsTable";

const Notifications = () => {
  return (
    <Row>
      <Col col={12} className="mb-4">
        <NotificationsTable />
      </Col>
    </Row>
  );
};

export default Notifications;
